import gsap, { Power2 } from 'gsap'
import {Swiper, Autoplay, EffectFade, Navigation, Pagination, Thumbs} from 'swiper'
import {loadBlockLazyImages} from "../helpers/lazy-load";


// block animate in
export function heroAnimationsAfterLoader() {
	gsap.fromTo('header', {top: '-6rem', opacity: 0 }, { top: 0, opacity: 1, delay: 0.2, duration: 0.8 })
    gsap.fromTo('.js-hero-slider-text', {top: '2rem', opacity: 0 }, { top: 0, opacity: 1, delay: 0.8, duration: 0.8 })
	
}




let heroSliderBlocks = $('.js-hero-slider-block')

if (heroSliderBlocks.length){
    heroSliderBlocks.each(function (){
        let $block = $(this)
        let $prevButton = $block.find('.swiper-button-prev')
        let $nextButton = $block.find('.swiper-button-next')
        let $pagination = $block.find('.swiper-pagination');

        let heroSwiper = new Swiper($block.find('.js-hero-slider')[0], {
            modules: [Autoplay, EffectFade, Navigation, Pagination],
            //effect: "fade",
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            autoplay: false,
            navigation: {
		          prevEl: $prevButton[0],
		          nextEl: $nextButton[0],
		        },
		        pagination: {
			        el: $pagination[0],
			        clickable: true,
			      },
            // fadeEffect: {
            //     crossFade: true
            // },
            on: {
                slideChange: function () {
                    // stop prev slide video and play current left slider video
                    $(this.el).find('video').each(function(i, el) {
                        el.pause()
                        el.currentTime = 0
                    })
                    let curSLide = $(this.slides[this.activeIndex])
                    let video = curSLide.find('video')
                    if (video.length){
                        video[0].play()
                    }

                    // youtube video
                    $(this.el).find('iframe').each(function(i, el) {
                        $(this).attr('src', '')
                    })
                    let iframe = curSLide.find('iframe')
                    iframe.attr('src', iframe.attr('data-img-src'))
                },

            },
        })


      


    })
}

